(() => {
  const button = document.querySelector('.scroll-to-top-button');

  if (!button) return;

  const showOffset = 500;

  const toggleButton = () => {
    if (window.scrollY > showOffset) {
      button.classList.add('is-visible');
    } else {
      button.classList.remove('is-visible');
    }
  };

  button.addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  });

  window.addEventListener('scroll', toggleButton, { passive: true });
  toggleButton();
})();